import React, { Component } from 'react'
import * as utils from "../../utils";
import * as activityFeedActions from "../../activity-feed/actions";
import * as fileUploadActions from "../../file-uploader/actions"

import FileUploadStage from "../../file-uploader/components/file-upload-stage";
import FileUploadButton from "../../file-uploader/components/file-upload-button";
import MentionEditor from "../../common/components/mention-editor";
import TagGuestsButton from "../../tag-guests/components/tag-guests-button";
import TagGuestsStage from "../../tag-guests/components/tag-guests-stage";

import { connect } from 'react-redux';

class CommentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tagSearchVisible: false,
      mentionEditorFocused: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleTagGuestSearch = this.toggleTagGuestSearch.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleMentionEditorFocus = this.handleMentionEditorFocus.bind(this);
    this.handleMentionEditorBlur = this.handleMentionEditorBlur.bind(this);
  }

  render() {
    const fileUpload = this.props.state.fileupload;
    const { isUploading, stagedFiles, exceedsFileLimit, atFileLimit } = fileUpload;
    const hasStagedFiles = stagedFiles.count > 0;

    let commentBtnText = "Comment";
    let stagedFilesClassName = "";
    let placeholderText = '';

    if (hasStagedFiles) {
      commentBtnText = "Upload";
      stagedFilesClassName = "single-photo-staged";
      placeholderText = "Add a photo caption...";
      if (stagedFiles.count > 1) {
        stagedFilesClassName = "multi-photo-staged";
        placeholderText = "Add a caption for your photos...";
      }
    }

    return (
      <form onSubmit={this.handleSubmit} className={`comment-form ${stagedFilesClassName}`} action="#">
        <MentionEditor
          onSubmit={this.handleSubmit}
          publicRef={(c) => {
            this.mentionEditor = c
          }}
          onFocus={this.handleMentionEditorFocus}
          onBlur={this.handleMentionEditorBlur}
          placeholder={placeholderText}
        />
        <FileUploadStage disabled={isUploading}/>
        <TagGuestsStage
          ref={(c) => this.TagGuestsStage = c}
          tagSearchVisible={this.state.tagSearchVisible}
          handleCloseSearch={this.toggleTagGuestSearch}
        />
        { !isUploading &&
          <div className="comment-action-buttons">
            <TagGuestsButton handleClick={this.toggleTagGuestSearch}/>

            <FileUploadButton
              buttonClass="small"
              disabled={exceedsFileLimit || atFileLimit}
              stagedFiles={stagedFiles}
              maxFiles={fileUpload.maxFiles}
              isUploading={isUploading}
            />

            <div className="comment-and-reset-buttons-container">
              { hasStagedFiles &&
              <button
                type="button"
                className="button-primary-inverse small reset-form-btn"
                onClick={this.handleCancelClick}
              >
                Cancel
              </button>
              }
              <button type="submit" className="button-primary small comment-button">{commentBtnText}</button>
            </div>
          </div>
        }
      </form>
    );
  }

  handleMentionEditorFocus(event){
    this.setState({mentionEditorFocused: true});
  }

  handleMentionEditorBlur(event){
    this.setState({mentionEditorFocused: false});
  }

  handleCancelClick(event) {
    event.preventDefault();
    this.resetCommentForm();
    return false;
  }

  resetCommentForm() {
    this.clearCommentInput();
    fileUploadActions.resetFileUploader();
    this.TagGuestsStage.resetStage();
  }

  handleSubmit(e) {
    e.preventDefault();

    evite.requestIdleCallback(() => {
      const { comment, mentions } = this.mentionEditor;
      const tags = this.TagGuestsStage.state.tags;
      const selectedFiles = this.props.state.fileupload.selectedFiles;

      if (comment.length >= window.comment_max_chars) {
        new ModalAjaxError({
          title: 'Error',
          body: `Comment must not exceed ${window.comment_max_chars} characters.`
        }).show();
        return;
      }

      if (!comment && selectedFiles.count === 0) {
        return;
      }

      if (selectedFiles.count > 0) {
        let fileArray = [];
        for(let file of selectedFiles.files) {
          fileArray.push(utils.b64toBlob(file));
        }
        fileUploadActions.uploadPhoto(fileArray, comment, tags, mentions);
      } else {
        activityFeedActions.postFeedComment(comment, tags, mentions);
        this.resetCommentForm();
      }

      this.clearCommentInput();
      this.TagGuestsStage.resetStage();
      this.setState({ tagSearchVisible: false });
    });
  }

  clearCommentInput() {
    this.mentionEditor.clearComment();
  }

  toggleTagGuestSearch() {
    this.setState({ tagSearchVisible: !this.state.tagSearchVisible });
  }
}

function mapStateToProps(state) {
  return {
    state: {
      activityfeed: state.activityfeed,
      fileupload: state.fileupload,
      tagguests: state.tagguests
    }
  }
}

const connectedCommentForm = connect(mapStateToProps)(CommentForm);

export default connectedCommentForm;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/comment-form.es6